import produce from "immer";
import {
  SET_LABELER_ID,
  SET_REVIEWER_ID,
  FETCH_USER_IN_PROJECT_SUCCESS,
} from "./constants";

// The initial state of the App
export const initialState = {
  labelerId: "",
  reviewerId: "",
  labelers: [],
  reviewers: [],
};

const membersReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_LABELER_ID:
        draft.labelerId = action.payload;
        break;
      case SET_REVIEWER_ID:
        draft.reviewerId = action.payload;
        break;
      case FETCH_USER_IN_PROJECT_SUCCESS:
        draft.labelers = action.payload.labelers;
        draft.reviewers = action.payload.reviewers;
        break;

      default:
    }
  });

export default membersReducer;
